/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Chevron from 'components/Chevron';
import { memo, useState } from 'react';

interface ICollapse {
  title: string;
  children: any;
  className?: string;
}
const Collapse = memo((props: ICollapse) => {
  const { title = '', children, className = '' } = props;
  const [active, setActive] = useState(true);

  return (
    <div className={`${className}`} data-testid="collapse">
      <div className={`${className}-header`}>
        <p>
          <b>{title.toUpperCase()}</b>
        </p>
        <span
          onClick={() => setActive(!active)}
          className={`${className}-header-arrow`}
        >
          <Chevron name={active ? 'up-mob' : 'down-mob'} />
        </span>
      </div>
      <div
        className={`${className}-body ${className}${
          active ? '-body-open' : '-body-hidden'
        }`}
      >
        {children}
      </div>
    </div>
  );
});

export default Collapse;
